import React, { useState, useRef, useEffect } from 'react';
import styles from './HelpButton.module.scss';

interface HelpButtonProps {
  helpText: string;
  className?: string;
}

const HelpButton: React.FC<HelpButtonProps> = ({ helpText, className }) => {
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const popupRef = useRef<HTMLDivElement>(null);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  const closePopup = () => {
    setIsOpen(false);
  };

  // クリック外でポップアップを閉じる
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        closePopup();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  // ESCキーでポップアップを閉じる
  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isOpen) {
        closePopup();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscKey);
    }

    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [isOpen]);

  return (
    <div className={`${styles.helpButtonContainer} ${className || ''}`}>
      <button
        ref={buttonRef}
        type="button"
        className={styles.helpButton}
        onClick={togglePopup}
        aria-label="ヘルプを表示"
        aria-expanded={isOpen}
        aria-haspopup="dialog"
      >
        ?
      </button>
      {isOpen && (
        <div
          ref={popupRef}
          className={styles.popup}
          role="dialog"
          aria-modal="true"
          aria-labelledby="help-popup-content"
        >
          <div className={styles.popupContent}>
            <div id="help-popup-content" className={styles.helpText}>
              {helpText}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HelpButton; 